import React from 'react'

import Image from '@/components/base/image'
import { Column, Row } from '@/components/base/gridview'
import Anchor from '@/components/base/anchor'

import { AsgBrandCardListProps } from './types'
import Icon from '@/components/base/icon/Icon'

const AsgBrandCardList: React.FunctionComponent<AsgBrandCardListProps> = (
  props
) => {
  return (
    <Row className="brand-card-list" gutter="lg">
      {props.data?.map((item, index) => (
        <Column
          key={item.title}
          xs={{ size: 12 }}
          sm={{ size: 6 }}
          lg={{ size: 4 }}
          xl={{ size: 4 }}
          className={'brand-card-item'}
        >
          {item.links && (
            <div className="link-wrapper">
              {item.links.map((item2, index2) => (
                <a
                  target="_blank"
                  key={index2}
                  href={item2.href}
                  rel="noreferrer"
                >
                  {item2.children}
                </a>
              ))}
            </div>
          )}

          {item.links && (
            <>
              {item.links.map((item2, index2) => (
                <a
                  target="_blank"
                  key={index2}
                  href={item2.href}
                  rel="noreferrer"
                  className="pdf-link"
                >
                  <Image
                    alt={item.title}
                    {...item.image}
                    style={{ borderRadius: '30px' }}
                  />
                  <Icon name="icon-file-download" />
                </a>
              ))}
            </>
          )}

          <span className="title" style={{ marginBottom: 0 }}>
            {item.firmName}
          </span>

          {item.title ? (
            <span className="title bottom">{item.title}</span>
          ) : null}
          {/* <span className="description">
            <div
              dangerouslySetInnerHTML={{
                __html: item.description,
              }}
            ></div>
          </span> */}
        </Column>
      ))}
    </Row>
  )
}

export default AsgBrandCardList
